<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <!-- <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" /> -->
    <div class="flex items-center h-10">
      <vs-chip class="ag-grid-cell-chip" :color="chipColor(value)" >
        <span>{{text(value)}}</span>
      </vs-chip>
    </div>
  </div>

</template>

<script>
import Vue from 'vue'
  export default {
      name: 'AttendAllStatus',
      // watch: {
      //   eventFlag(){
      //     if(this.$store.getters['attend/getInsightLate'](this.params.data.user_id)){
      //       this.value = 2
      //       Vue.set(this.params.data, 'state', 2)
      //     } else if(this.$store.getters['attend/getInsightMiss'](this.params.data.user_id)){
      //       this.value = 3
      //       Vue.set(this.params.data, 'state', 3)
      //     } else{
      //       this.value = 1
      //       Vue.set(this.params.data, 'state', 1)
      //     }
      //   }
      // },
      computed: {
        chipColor() {
          return (value) => {
            if(value === 1) return "success"
            else if(value === 2) return "warning"
            else if(value === 3) return "danger"
            else "success"
          }
        },
        text(){
          return (value) => {
            if(value === 1) return "출석"
            else if(value === 2) return "지각"
            else if(value === 3) return "결석"
            else "출석"
          }
        },
        attendDays(){
          return this.$store.state.attend.attendDays
        },
        // eventFlag(){
        //   return this.$store.state.attend.eventFlag
        // },
      },
      data() {
        return {
          value:1
        }
      },
      created(){
        this.value = this.params.value
      },
      methods: {
        editState(val) {
          this.$store.commit('attend/DELETE_ATTEND_MISS_DATA', {user_id:this.params.data.user_id, attend_id:this.params.data.attend_id})
          this.$store.commit('attend/DELETE_ATTEND_LATE_DATA', {user_id:this.params.data.user_id, attend_id:this.params.data.attend_id})
          if(val == 2){
            this.$store.commit('attend/UPDATE_ATTEND_LATE_DATA', {user_id:this.params.data.user_id, attend_id:this.params.data.attend_id})
          }
          else if(val == 3){
            this.$store.commit('attend/UPDATE_ATTEND_MISS_DATA', {user_id:this.params.data.user_id, attend_id:this.params.data.attend_id})
          }
          this.value = val
          Vue.set(this.params.data, 'state',val)
          // this.$store.commit('attend/SET_EVENT_FLAG')
        }
      }
  }
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
